import { render } from "./PainelRelatorioVendasIndex.vue?vue&type=template&id=3976b6bc&scoped=true&ts=true"
import script from "./PainelRelatorioVendasIndex.vue?vue&type=script&lang=ts"
export * from "./PainelRelatorioVendasIndex.vue?vue&type=script&lang=ts"

import "./PainelRelatorioVendasIndex.vue?vue&type=style&index=0&id=3976b6bc&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3976b6bc"]])

export default __exports__